<template>
    <form
        class="mt-5 grid-cols-layout border-b border-gray-300 pb-5 lg:grid"
        @submit.prevent="$emit('update', mode)"
    >
        <div class="mb-6 lg:mb-0 lg:mt-4">
            <h3
                class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
            >
                Themes
            </h3>
            <p class="max-w-xs text-sm text-gray-500">
                Change the appearance of TOPOL Editor with one of the predefined
                color themes.
            </p>
        </div>
        <div class="mx-auto w-full rounded-[6px] bg-white shadow-card lg:mx-0">
            <div
                class="flex flex-wrap justify-center gap-6 border-b border-gray-200 px-6 pb-5 pt-[23px] lg:justify-between"
            >
                <div
                    class="cursor-pointer rounded-[6px] border bg-gray-300 shadow-sm"
                    :class="{
                        'border-orange-500': mode === 'dark',
                        'border-gray-300': mode !== 'dark',
                    }"
                    @click="mode = 'dark'"
                >
                    <div class="">
                        <img
                            src="https://d1vyenbk43iobe.cloudfront.net/application/images/editor-dark.svg"
                            alt=""
                        />
                    </div>

                    <div
                        class="rounded-b-md bg-gray-50 pb-[21px] pl-[14px] pt-4"
                    >
                        <RadioInput
                            v-model="mode"
                            option="dark"
                            label="Dark mode (default)"
                            name="editor"
                        />
                    </div>
                </div>

                <div
                    class="cursor-pointer rounded-[6px] border bg-gray-300 shadow-sm"
                    :class="{
                        'border-orange-500': mode === 'light',
                        'border-gray-300': mode !== 'light',
                    }"
                    @click="mode = 'light'"
                >
                    <div class="">
                        <img
                            src="https://d1vyenbk43iobe.cloudfront.net/application/images/editor-light.svg"
                            alt=""
                        />
                    </div>

                    <div
                        class="rounded-b-md bg-gray-50 pb-[21px] pl-[14px] pt-4"
                    >
                        <RadioInput
                            v-model="mode"
                            label="Light mode"
                            option="light"
                            name="editor"
                        />
                    </div>
                </div>
            </div>

            <div class="flex justify-end">
                <div class="my-3 pr-6">
                    <LockableButton
                        :disabled="mode === editorSettings.theme"
                        type="submit"
                        color="yellow"
                        size="sm"
                        :locked="!hasAnyProSubscriptionOrTrial"
                        :lock-message="`You need a ${planName} subscription to update editor settings.`"
                    >
                        Save changes
                    </LockableButton>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup lang="ts">
import IEditorSettings from '@/types/Settings/IEditorSettings';
import { PropType } from 'vue';
import { useSubscriptionLabel } from '@/composables/useSubscriptionLabel';

const props = defineProps({
    editorSettings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
});

defineEmits(['update']);

const { hasAnyProSubscriptionOrTrial } = useSubscriptions();
const { planName } = useSubscriptionLabel();

const mode = ref(props.editorSettings.theme);
</script>
